
import { ref, computed, defineComponent, getCurrentInstance, watch } from "vue-demi";
import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { API_TNewsItem } from "@/models/notifications";

export default defineComponent({
  name: "NotificationsTemplate",

  components: {
    NotificationsTag: () => import("@/modules/Notifications/components/NotificationsTag.vue"),
    NotificationsDate: () => import("@/modules/Notifications/components/NotificationsDate.vue"),
  },

  setup() {
    const instance = getCurrentInstance()?.proxy;
    const route = instance?.$route;

    const routeParamsId = computed(() => Number(route.params.id ?? 0));

    const newItem = ref();

    async function fetchNewsItem() {
      try {
        const { data } = await axios.get<API_TNewsItem>(API_ROUTES.NEWS_ITEM(routeParamsId.value));

        if (!data) return;

        newItem.value = data;
      } catch (error) {
        console.error(`Error fetching NEWS_ITEM:`, error);
      }
    }

    watch(
      routeParamsId,
      async (newId, oldId) => {
        if (newId === oldId) return;

        if (newId && newId !== 0) {
          await fetchNewsItem();
        }
      },
      { immediate: true }
    );

    return { newItem };
  },
});
